import styles from './ErrorPage.module.scss';
import { Svg } from '@core/components/Svg/Svg';

export const ErrorPage = () => {
    const preloader = document.getElementById('preloader');
    if (preloader) preloader.remove();
    
    return (
        <div className={styles.authFailedContainer}>
            <Svg name="logo" isIcon={false} className={styles.logo} raw={false} />
            <div className={styles.content}>
                Under maintenance.
                <br /> Please try again later.
            </div>
        </div>
    );
};
